var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { baseGetApi, publicApi, rootApi, rootApiDelete, rootApiPatch, rootApiPost, } from './../index';
export var getBVersions = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, publicApi('getVersions')];
    });
}); };
export var getFVersions = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, rootApi('/versions')];
    });
}); };
export var getLicenseVersion = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, baseGetApi('licence', 'get')];
    });
}); };
export var getMonitoring = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, baseGetApi('monitoring', 'get')];
    });
}); };
export var getMonitoringGraph = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, baseGetApi('graphdata', 'get')];
    });
}); };
export var sessions = {
    getUser: function () { return __awaiter(void 0, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, baseGetApi('user', 'get')];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, res.data];
            }
        });
    }); },
    getUserSession: function () { return __awaiter(void 0, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, baseGetApi('usersession', 'get')];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, res.data];
            }
        });
    }); },
    getUserAction: function (filter) { return __awaiter(void 0, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, baseGetApi('useraction', 'get', {
                        payload: {
                            data: {},
                            limit: 5000,
                            offset: 0,
                            sort: {
                                field: 'created_on',
                                dir: 'desc',
                            },
                            filter: filter,
                        },
                    })];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, res.data];
            }
        });
    }); },
    addUserSession: function (user_id) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, baseGetApi('usersession', 'add', {
                        payload: {
                            data: {
                                config: {},
                                sessioncomment: 'Constant session',
                                user_id: user_id,
                            },
                        },
                    })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); },
    deleteUserSession: function (session_id) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, baseGetApi("usersession/".concat(session_id), 'delete')];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); },
};
export var sessionStorage = {
    get: function () { return __awaiter(void 0, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, baseGetApi('activedirectory', 'get')];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, res.data];
            }
        });
    }); },
    update: function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, baseGetApi('activedirectory', 'update', {
                        payload: { data: data },
                    })];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, res.status];
            }
        });
    }); },
};
export var content = {
    getFonts: function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, rootApi(content._fontsUrl)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); },
    addFonts: function (payload) { return __awaiter(void 0, void 0, void 0, function () {
        var file, text, formData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    file = payload.file, text = payload.text;
                    formData = content.getFormData(file, text, content._font);
                    return [4 /*yield*/, rootApiPost(content._fontsUrl, formData, content._headers)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); },
    deleteFont: function (name) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, rootApiPost(content._fontsDeleteUrl, { name: name })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); },
    getVideos: function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, rootApi(content._videosUrl)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); },
    updateVideo: function (id) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, rootApiPatch(content._videosUrl, { id: id })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); },
    addVideo: function (payload) { return __awaiter(void 0, void 0, void 0, function () {
        var file, text, formData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    file = payload.file, text = payload.text;
                    formData = content.getFormData(file, text, content._video);
                    return [4 /*yield*/, rootApiPost(content._videosUrl, formData, content._headers)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); },
    deleteVideo: function (id) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, rootApiDelete(content._videosUrl, { data: { id: id } })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); },
    getImages: function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, rootApi(content._imagesUrl)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); },
    //TODO: тут пока заглушка как видео, а должен быть ContentImageItem
    addImage: function (payload) { return __awaiter(void 0, void 0, void 0, function () {
        var file, text, formData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    file = payload.file, text = payload.text;
                    formData = content.getFormData(file, text, content._image);
                    return [4 /*yield*/, rootApiPost(content._imagesUrl, formData, content._headers)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); },
    deleteImage: function (name) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, rootApiDelete(content._imagesUrl, { name: name })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); },
    getNews: function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, rootApi(content._newsUrl)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); },
    addNews: function (payload) { return __awaiter(void 0, void 0, void 0, function () {
        var date, text, title;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    date = payload.date, text = payload.text, title = payload.title;
                    return [4 /*yield*/, rootApiPost(content._newsUrl, { date: date, text: text, title: title })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); },
    deleteNews: function (id) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, rootApiDelete(content._newsUrl, { data: { id: id } })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); },
    getRunningLines: function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, rootApi(content._runninglinesUrl)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); },
    addRunningLine: function (text) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, rootApiPost(content._runninglinesUrl, { text: text })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); },
    deleteRunningLine: function (id) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, rootApiDelete(content._runninglinesUrl, { data: { id: id } })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); },
    _font: 'font',
    _video: 'video',
    _image: 'image',
    _newsUrl: '/api/news/',
    _fontsUrl: '/api/fonts/',
    _videosUrl: '/api/videos/',
    _imagesUrl: '/api/images/',
    _runninglinesUrl: '/api/runninglines',
    _fontsDeleteUrl: '/api/fonts/delete',
    _headers: {
        headers: {
            'content-type': 'multipart/form-data',
        },
    },
    getFormData: function (file, fileName, type) {
        var formData = new FormData();
        formData.append(type, file);
        formData.append('name', fileName);
        return formData;
    },
};
